import e from "react";
import { SnackbarContent as p, closeSnackbar as c, SnackbarProvider as s, enqueueSnackbar as l } from "notistack";
import { M as f } from "./MzAlert-a557853a.js";
import { s as u } from "./styled-38387a7e.js";
import "./createSvgIcon-b5d2ebc3.js";
import "./createSvgIcon-9d6f669e.js";
import "./createTheme-02ce03eb.js";
import "./useTheme-efe1290c.js";
import "./useThemeProps-ee4acb93.js";
import "./debounce-c2e7efcb.js";
import "./ownerWindow-a0b5b7a5.js";
import "./ownerDocument-5430cd5b.js";
import "./useEventCallback-fe4fd69c.js";
import "./useId-a21bd5c3.js";
import "./unsupportedProp-3dbf01f6.js";
import "./useControlled-cc2d41cb.js";
import "./useIsFocusVisible-4693b580.js";
import "./Close-59bb9741.js";
import "./ButtonBase-a4bd3410.js";
import "./TransitionGroupContext-9484fef7.js";
import "@emotion/react";
import "./refType-e39501b1.js";
import "./elementTypeAcceptingRef-c7effbb1.js";
import "./chainPropTypes-004bf492.js";
import "./Paper-ea294db9.js";
import "./useTheme-d46e2483.js";
import "./integerPropType-e817878c.js";
import "@emotion/styled";
function d(t, r) {
  const { id: m, message: o, severity: i } = t;
  return /* @__PURE__ */ e.createElement(p, { ref: r, role: "alert" }, /* @__PURE__ */ e.createElement(
    f,
    {
      severity: i,
      onClose: () => {
        c(m);
      }
    },
    o
  ));
}
const b = e.forwardRef(d), N = u(k)(() => ({}));
function k(t) {
  return /* @__PURE__ */ e.createElement(
    s,
    {
      Components: {
        default: b
      },
      ...t
    }
  );
}
function S(t, { placement: r, ...m } = {}) {
  let o = "bottom", i = "center";
  if (r) {
    const n = r.split("-");
    o = n[0], i = n[1];
  }
  const a = {
    anchorOrigin: {
      vertical: o,
      horizontal: i
    },
    ...m
  };
  l(t, a);
}
const Q = { show: S };
export {
  N as MzSnackbarProvider,
  Q as default
};
